import Vue from 'vue'
import store from '../store/index'
import * as _ from 'lodash'
import StateHelper from './state-abbreviation'

export default {
  data () {
    return {
      static_promise:null
    }
  },
  login: function(client_id,login) {
    return new Promise((resolve,reject) => {
      Vue.http.post(process.env.API_URL+ '/auth/login', { "id": client_id, 'login': login } ).then(response => {
          if (response.status == 200  && ! response.data.error) {
            this.setUserData(response.data);
            resolve(true)
          }
          else{
            resolve(false)
          }
        }).catch(err => {
          resolve(false)
        })
    })
  },
  getFilterSetDetails: function(){
    return new Promise((resolve,reject) => {
      let api_url = process.env.API_URL + '/filtersets';
      Vue.http.get(api_url,{params:  {'token': store.getters.accessToken}}).then(response => {
        let filter_sets = response.data || response;
        let context = this;
        _.each(filter_sets, (next_item) => {
          if(next_item.status == "Active"){
            context.setStatesAreaCode(StateHelper.getStateByAbbreviation(next_item.states), next_item.detail);
          }
        })
        setTimeout( () => {
          resolve(true)
        }, 5000);
      }).catch(error => {
        reject(true)
      })
    })
  },
  saveClientData: function() {
    var context = this;
    return new Promise((resolve, reject) => {
      let filter_sets = context.getFormattedData();
      let api_url = process.env.API_URL + '/filtersets';
      Vue.http.post(api_url, {'pickups': filter_sets}).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  getSelectedArea: function(state) {
    let selectedAreas = store.getters.selectedAreas;
    let response = _.find(selectedAreas, {'state': state});
    return response;
  },
  setUserData: function(user_data) {
    let user = user_data;
    delete user.filter_sets;
    store.commit("setUser", user);
    store.commit("setAccessToken", user.token);
    store.commit("setClientId", user.id);
    store.commit("setCompany", user.company);
    localStorage.setItem('user', JSON.stringify(user));
  },
  setSelectedAreas: function(filter_sets) {
    let selectedAreas = [];
    _.each(filter_sets, (filter_set) => {
      selectedAreas.push({
        filter_set_id: filter_set.id || null, 
        abbreviation: filter_set.states,
        state: StateHelper.getStateByAbbreviation(filter_set.states),
        area_codes: [],
        status: filter_set.status,
        prev_status: filter_set.status 
      })
    }) 
    store.commit('setSelectedAreas', selectedAreas);
  },
  setExcludedAreas: function(exclusions) {
    let excluded_areas = [];
    _.each(exclusions, (state) => {
      excluded_areas.push({
        state: StateHelper.getStateByAbbreviation(state),
        abbreviation: state
      })
    })
    store.commit('setExcludedAreas', excluded_areas);
  },
  setStatesAreaCode: function(state, filter_set) {
    let selected_area = this.getSelectedArea(state);
    let selected_area_codes = [];
    
    let zip_codes = filter_set.origin_zip;
    zip_codes = _.split(zip_codes, ',');

    this.getZipCodesByState(filter_set.origin_state).then(area_codes => {
      _.each(zip_codes, (zip_code) => {
        zip_code = _.split(zip_code, '*');
        console.log('state', state, zip_codes)
        if (zip_code.length > 1) {
          zip_code = zip_code[0];
          _.each(area_codes, (next_item) => {
            console.log("in area _ codes", next_item, state);
            if (_.startsWith(next_item.zipcode, zip_code, 0)) {
              selected_area_codes.push({
                area_code: next_item.area_code,
                zip_code: next_item.zipcode 
              })
            }
          })
        } 
        else {
          if(_.isEmpty(zip_code[0])){
            return;
          }
          zip_code = zip_code[0];
          let area_code = _.find(area_codes, {"zipcode": zip_code});
          selected_area_codes.push({
            area_code: area_code.area_code,
            zip_code: area_code.zipcode 
          })
        }
        console.log(zip_code, selected_area_codes, 'selected_areas', selected_area);
      })
      selected_area.area_codes = selected_area_codes;
      selected_area.total_area_codes = area_codes.length; 
      store.commit('updateSelectedArea', selected_area)
      console.log('area_codes', selected_area)
    })

  },
  getZipCodesByState: function(state) {
    return new Promise((resolve, reject) => {
      Vue.http.get('https://valet.irelo.com/api/service/areacodes/' + state).then(response => {
        response = response.data || response;
        resolve(response);
      })
      .catch(error => {
        reject();
      })
    })
  },
  getFormattedCodes: function(selected_area){
    let selected_area_codes = JSON.parse(JSON.stringify(selected_area.area_codes))
    let codes = _.join(_.map(selected_area.area_codes, 'area_code'), ',')
    selected_area_codes = _.filter(selected_area_codes, (area)=>{
      if(_.isEmpty(area.additional_areacodes)){
        return false
      }
      return true
    })
    let additonal_codes =_.join(_.map(selected_area_codes, 'additional_areacodes'), ',')
    let total_codes = additonal_codes ? codes + "," + additonal_codes : codes
    return total_codes
  },
  getFormattedData: function() {
    let filter_sets = [];
    let selected_areas = store.getters.selectedAreas;
    let excluded_areas = this.getExcludedAreas();

    for(var i = 0; i < selected_areas.length; i++){
      
      let filter_set = {
        state: selected_areas[i].abbreviation,
        areacodes: this.getFormattedCodes(selected_areas[i]) ,
        zipcodes: (selected_areas[i].area_codes.length != selected_areas[i].total_area_codes) ? _.join(_.map(_.filter(selected_areas[i].area_codes,(code)=>{
          if(_.isEmpty(code.zip_code)){
            return false
          }
          return true
        }), 'zip_code'), ',') : '',
        exclusions: _.join(_.map(excluded_areas, 'abbreviation'), ','),
        status: selected_areas[i].status || "Active",
        prev_status : selected_areas[i].prev_status || ""
      }
      if (selected_areas[i].filter_set_id) {
        filter_set['filter_set_id'] = selected_areas[i].filter_set_id
      }

      filter_sets.push(filter_set);
    }

    return filter_sets;
  },
  getExcludedAreas() {
    let excluded_areas = store.getters.excludedAreas;
    _.filter(excluded_areas, (excluded_area) => {
      return excluded_area.abbreviation != "AK" || excluded_area.abbreviation != "HI", excluded_area.abbreviation != "PR";
    })
    let compulsory_states = [
      {
        state: "Alaska",
        abbreviation: "AK"
      },
      {
        state: "Hawaii",
        abbreviation: "HI"
      },
      {
        state: "Puerto Rico",
        abbreviation: "PR"
      }
    ];

    excluded_areas = excluded_areas.concat(compulsory_states);
    return excluded_areas;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/mover-helper.js